import { Container, Grid, Button, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Alert } from "reactstrap"

import {
  updateLicense,
  clearAllGlobalLicenseMessages,
} from "../store/actions";

import spinner from "../assets/images/loadingGif.gif";
// import { AddonsModal } from "./AddonsModal";
import ComplianceAddonsModal  from "./ComplianceAddonsModal";

const EditLicenseAndAddOns = (props) => {
  const data = props.data;
  const [subscriptionModelData, setSubscriptionModelData] = useState(
    data["Subscription Model"]
  );
  // const [addAddonsIsOpen, setAddAddonsIsOpen] = useState(false);
  // const updateAddons = (addons) => {
  //   const subscriptionModel = {...subscriptionModelData};
  //   subscriptionModel["Add ons"] = addons;
  //   setSubscriptionModelData(subscriptionModel);  
  // }

  const planParameters = [
    "Price",
    "Number Of Assets",
    "Scan Frequency",
    "Security Posture",
    "Security Posture Report",
    "Support Response",
  ];

  const numberPlanParameters = ["Price", "Number Of Assets"];

  // const planAddOnsParameters = ["Event Insight", "Cost Insight", "Cost Optimization", "IaaC"];
  const planAddOnsParameters = ["Event Insight", "Cost Insight", "Cost Optimization"];

  // console.log("~~~subscriptionModelData", subscriptionModelData);
  const [complianceAddOnsData, setComplianceAddOnsData] = useState(
    data["Compliance Add Ons"]
  );
  const [addComplianceAddonsIsOpen, setAddComplianceAddonsIsOpen] =
    useState(false);
  const updateComplianceAddons = (addons) => {
    setComplianceAddOnsData(addons);
  };

  const handleSubscriptionModelChange = (e, parameter, plan) => {
    const updatedData = [...subscriptionModelData];
    const targetPlanRow = updatedData.find((row) => row.Name === plan);
    if (planAddOnsParameters.includes(parameter)) {
      //For Add Ons parameters
      const targetAddOnRow = targetPlanRow["Add ons"].find(
        (row) => row.Name === parameter
      );
      targetAddOnRow["Price"] = parseInt(e.target.value);
    } else {
      //For Plan parameters
      if (numberPlanParameters.includes(parameter)) {
        targetPlanRow[parameter] = parseInt(e.target.value);
      } else {
        targetPlanRow[parameter] = e.target.value;
      }
    }
    console.log("~~~ updatedData subscription, after change ", updatedData);
    setSubscriptionModelData(updatedData);
  };

  const handleComplianceAddOnsChange = (e, addOnName, subscriptionName) => {
    const updatedData = complianceAddOnsData.map(
      (addOnObj) => {
        if(addOnObj.Name === addOnName && addOnObj.Subscription === subscriptionName) {
          return {...addOnObj, Price: parseInt(e.target.value)};
        } else {
          return addOnObj;
        }
      }
    );
    console.log("~~~ updatedData compliance, after change ", updatedData);
    setComplianceAddOnsData(updatedData);
  };

  const handleUpdateLicense = (e) => {
    e.preventDefault();
    const license = {
      "Subscription Model": subscriptionModelData,
      "Compliance Add Ons": complianceAddOnsData,
    };
    console.log("~~ Submitting data for updating license ", license);
    props.updateLicense(license);
  };

  //For displaying message for updating organization account
  let updateLicenseMsg = props.updateLicenseMessage;
  let updateLicenseErr = props.updateLicenseError;
  useEffect(() => {
    console.log("updateLicenseMsg = " + updateLicenseMsg);
    if (updateLicenseMsg || updateLicenseErr) {
      console.log("Inside if, updateLicenseMsg = " + updateLicenseMsg);
      //Clear all messages after 10 seconds
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [updateLicenseMsg, updateLicenseErr, props]);

  const renderSubscriptionModelTable = () => {
    return (
      <div>
        {/* <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={() => {
            setAddAddonsIsOpen(true);
          }}
        >
          Add Addons
        </Button> */}
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Free</th>
              <th>Basic</th>
              <th>Standard</th>
              <th>Premium</th>
              {/* <th>Enterprise</th> */}
            </tr>
          </thead>
          <tbody>
            {planParameters.map((parameter, index) => (
              <tr key={index}>
                <td>
                  {parameter === "Price"
                    ? "Price in $, Billed Monthly"
                    : parameter}
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type={
                      numberPlanParameters.includes(parameter)
                        ? "number"
                        : "text"
                    }
                    // value={basicPlanDataState[parameter]}
                    value={
                      subscriptionModelData.find(
                        (plan) => plan.Name === "Free"
                      )[parameter]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Free")
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type={
                      numberPlanParameters.includes(parameter)
                        ? "number"
                        : "text"
                    }
                    // value={basicPlanDataState[parameter]}
                    value={
                      subscriptionModelData.find(
                        (plan) => plan.Name === "Basic"
                      )[parameter]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Basic")
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type={
                      numberPlanParameters.includes(parameter)
                        ? "number"
                        : "text"
                    }
                    // value={standardPlanData[parameter]}
                    value={
                      subscriptionModelData.find(
                        (plan) => plan.Name === "Standard"
                      )[parameter]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Standard")
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type={
                      numberPlanParameters.includes(parameter)
                        ? "number"
                        : "text"
                    }
                    // value={premiumPlanData[parameter]}
                    value={
                      subscriptionModelData.find(
                        (plan) => plan.Name === "Premium"
                      )[parameter]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Premium")
                    }
                  />
                </td>
              </tr>
            ))}
            {planAddOnsParameters.map((parameter, index) => (
              <tr key={100 + index}>
                <td>{parameter} Price in $, Billed Monthly</td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    // value={basicPlanDataState[parameter]}
                    value={
                      ( (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"] === null) ||
                        (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"].length === 0) 
                      ) ? ""
                      : subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"]
                          .find((addons) => addons.Name === parameter)["Price"]
                    }
                    onChange={ (e) => {
                        if( (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"] === null) ||
                          (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"].length === 0)
                        ) {
                          handleSubscriptionModelChange(e, parameter, "Free");
                        } 
                      }
                    }
                    disabled={
                      ( (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"] === null) ||
                        (subscriptionModelData.find((plan) => plan.Name === "Free")["Add ons"].length === 0) 
                      )
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    // value={basicPlanDataState[parameter]}
                    value={
                      subscriptionModelData
                        .find((plan) => plan.Name === "Basic")
                        ["Add ons"].find((addons) => addons.Name === parameter)[
                        "Price"
                      ]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Basic")
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    // value={standardPlanData[parameter]}
                    value={
                      subscriptionModelData
                        .find((plan) => plan.Name === "Standard")
                        ["Add ons"].find((addons) => addons.Name === parameter)[
                        "Price"
                      ]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Standard")
                    }
                  />
                </td>
                <td>
                  <TextField
                    variant="outlined"
                    size="small"
                    // value={premiumPlanData[parameter]}
                    value={
                      subscriptionModelData
                        .find((plan) => plan.Name === "Premium")
                        ["Add ons"].find((addons) => addons.Name === parameter)[
                        "Price"
                      ]
                    }
                    onChange={(e) =>
                      handleSubscriptionModelChange(e, parameter, "Premium")
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Modal to add general addons */}
        {/* <AddonsModal
          isOpen={addAddonsIsOpen}
          setOpen={setAddAddonsIsOpen}
          addons={subscriptionModelData["Add ons"]}
          updateAddons={updateAddons}
        /> */}

        {/* Modal to add compliance addons */}
        <ComplianceAddonsModal
          isOpen={addComplianceAddonsIsOpen}
          setOpen={setAddComplianceAddonsIsOpen}
          // addons={complianceAddOnsData}
          // updateComplianceAddons={updateComplianceAddons}
        />
      </div>
    );
  };

  const renderComplianceAddOnsTable = () => {
    const data = {};
    complianceAddOnsData.forEach(addOn => {
      const name = addOn.Name;
      const subscription = addOn.Subscription;

      if (!data[name]) {
        data[name] = { Basic: "", Standard: "", Premium: "" };
      }

      data[name][subscription] = addOn.Price;
    });
    
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            setAddComplianceAddonsIsOpen(true);
          }}
        >
          Add Compliance Addons
        </Button>

        <table>
          <thead>
          <tr>
              <th></th>
              <th colSpan="3" style={{ textAlign: 'center'}}>Price in $, Billed Monthly</th>
            </tr>
            <tr >
              <th>Name</th>
              <th>Free</th>
              <th>Basic</th>
              <th>Standard</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(data).map(name => (
              <tr key={name}>
                <td>{name}</td>
                <td>
                  <TextField 
                    variant="outlined"
                    size="small"
                    type="number"
                    value={data[name].Free}
                    onChange={(e) => handleComplianceAddOnsChange(e, name, "Free")}
                  />
                </td>
                <td>
                  <TextField 
                    variant="outlined"
                    size="small"
                    type="number"
                    value={data[name].Basic}
                    onChange={(e) => handleComplianceAddOnsChange(e, name, "Basic")}
                  />
                </td>
                <td>
                  <TextField 
                    variant="outlined"
                    size="small"
                    type="number"
                    value={data[name].Standard}
                    onChange={(e) => handleComplianceAddOnsChange(e, name, "Standard")}
                  />
                </td>
                <td>
                  <TextField 
                    variant="outlined"
                    size="small"
                    type="number"
                    value={data[name].Premium}
                    onChange={(e) => handleComplianceAddOnsChange(e, name, "Premium")}
                  />
                </td>                                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div>
      <Container>
        <Grid container justifyContent="center">
          {props.isUpdatingLicense && (
            <div
              style={{
                display: "flex",
                direction: "column",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              <img src={spinner} width="24px" alt="Spinner" />
            </div>
          )}
          {props.updateLicenseMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.updateLicenseMessage}
            </Alert>
          )}
          {props.updateLicenseError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while updating license.
              {JSON.stringify(props.updateLicenseError?.message)}
            </Alert>
          )}

          <form onSubmit={handleUpdateLicense}>
            <h5>Subscription Model</h5>
            {renderSubscriptionModelTable()}
            <br />
            <br />
            <h5>Compliance Add Ons</h5>
            {renderComplianceAddOnsTable()}
            <br />
            <Button
              type="submit"
              variant="contained"
              disabled={props.isUpdatingLicense}
              onClick={handleUpdateLicense}
            >
              Update
            </Button>
            <br />
            <br />
          </form>
        </Grid>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { 
    isUpdatingLicense, 
    updateLicenseError, 
    updateLicenseMessage 
  } = state.globalLicense;

  return {
    isUpdatingLicense,
    updateLicenseError,
    updateLicenseMessage,
  };

}

const mapDispatchToProps = (dispatch) => {
  return {
    updateLicense: (license) => dispatch(updateLicense(license)),
    clearAllMessages: () => dispatch(clearAllGlobalLicenseMessages()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLicenseAndAddOns);